module.exports = __webpack_public_path__ + "your-resources.f127c355313b79d451a024e7035eef94.svg";